export var trackCustomEvent = function trackCustomEvent(_ref) {
  var eventCategory = _ref.eventCategory,
      eventAction = _ref.eventAction,
      eventName = _ref.eventName,
      eventValue = _ref.eventValue;

  if (process.env.NODE_ENV === "production" || window.dev === true) {
    if (!window._paq) return;
    var _window = window,
        _paq = _window._paq,
        dev = _window.dev;

    _paq.push(["trackEvent", eventCategory, eventAction, eventName, eventValue]);

    if (dev) {
      console.debug("[Matomo] event tracked, category: " + eventCategory + ", action: " + eventAction + ", name: " + eventName + ", value: " + eventValue);
    }
  }
};